import { render, staticRenderFns } from "./RequestsByType.vue?vue&type=template&id=2758b0b0"
import script from "./RequestsByType.vue?vue&type=script&lang=js"
export * from "./RequestsByType.vue?vue&type=script&lang=js"
import style0 from "./RequestsByType.vue?vue&type=style&index=0&id=2758b0b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports